<template class="full-height">
  <div class="app-container" id="log-page" style="position: relative; height: 100%; padding: 15px">
    <el-tabs v-model="activeName" type="border-card" style="min-height: 100%">
      <el-tab-pane label="表格" name="logTable" style="min-height: 100%">
        <el-form :inline="true" class="search-form" @submit.native.prevent>
          <el-row>
            <el-col :span="24">
              <el-form-item label="操作行為">
                <el-select v-model="listQuery.actionType" clearable placeholder="請選擇操作行為">
                  <el-option
                    v-for="item in actionOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="查詢">
                <el-input
                  v-model="listQuery.userName"
                  @keyup.enter.native="getList"
                  placeholder="請輸入使用者名稱"
                  clearable
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="getList"
                  icon="el-icon-search"
                  circle
                  style="margin-left: 5px"
                  :disabled="listLoading"
                ></el-button>
                <el-button
                  style="cursor: pointer"
                  type="success"
                  :loading="listLoading"
                  circle
                  icon="el-icon-refresh-left"
                  @click="refreshList"
                ></el-button>
                <el-tooltip content="匯出 Excel">
                  <el-button
                    style="cursor: pointer"
                    type="warning"
                    :loading="exportExcelLoading"
                    circle
                    icon="el-icon-download"
                    @click="exportExcel"
                  ></el-button>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="操作區間">
                <el-date-picker
                  v-model="dateFilter"
                  type="daterange"
                  :clearable="false"
                  align="right"
                  :picker-options="pickerOptions"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="開始日期"
                  end-placeholder="結束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <h4 style="margin-top: 12px; margin-bottom: 8px">{{ title }}</h4>
        <div style="position: relative; height: 80%">
          <el-table
            ref="logTable"
            class="logTable"
            size="mini"
            stripe
            highlight-current-row
            :data="list"
            v-loading="listLoading"
            border
            style="width: 100%"
            height="100%"
          >
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作行為" prop="description"> </el-table-column>
            <el-table-column label="使用者" width="150" prop="userName" align="center">
            </el-table-column>
            <el-table-column label="IP" width="130" prop="ip" align="center"> </el-table-column>
            <el-table-column label="操作時間" width="150" prop="createDT" align="center">
            </el-table-column>
          </el-table>
        </div>
        <Pagination
          v-show="total > 0"
          layout="prev, pager, next"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.count"
          @pagination="getList"
        />
      </el-tab-pane>

      <el-tab-pane label="圖表" name="logChart">
        <el-form :inline="true" class="search-form" @submit.native.prevent>
          <el-row>
            <el-col :span="24">
              <el-form-item label="操作行為">
                <el-select v-model="chartQuery.actionType" clearable placeholder="請選擇操作行為">
                  <el-option
                    v-for="item in actionOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="查詢">
                <el-input
                  v-model="chartQuery.userName"
                  @keyup.enter.native="getLogStatistical"
                  placeholder="請輸入使用者名稱"
                  clearable
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="getLogStatistical"
                  icon="el-icon-search"
                  circle
                  style="margin-left: 5px"
                  :disabled="chartLoading"
                ></el-button>
                <el-button
                  style="cursor: pointer"
                  type="success"
                  :loading="chartLoading"
                  circle
                  icon="el-icon-refresh-left"
                  @click="refreshChart"
                ></el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="操作區間">
                <el-select v-model="chartQuery.type" placeholder="請選擇操作行為">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <h4 style="margin-top: 12px">{{ title }}</h4>
        <div v-loading="chartLoading">
          <LogLineChart
            :chart-data="lineChartData"
            :title="chartQuery.userName"
            v-if="activeName === 'logChart'"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import LogLineChart from './components/LogLineChart'
import { getActionType, getHistoryLogs, getLogStatistical } from '@/api/log'
import request from '@/utils/request'

export default {
  name: 'Log',
  components: {
    Pagination,
    LogLineChart,
  },
  data() {
    return {
      title: this.$store.getters.userInfo.agencyCode ? '' : '智遊旅程 雲市集方案',
      activeName: 'logTable',
      total: 0,
      loading: false,
      exportExcelLoading: false,
      list: [],
      actionOptions: [],
      typeOptions: [
        { key: 1, value: '近7日' },
        { key: 2, value: '近14日' },
        { key: 3, value: '本月(以週統計)' },
        { key: 4, value: '上月(以週統計)' },
      ],
      listLoading: false,
      chartLoading: false,
      dateFilter: [
        new Date(
          Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7)
        )
          .toISOString()
          .replace('T', ' ')
          .slice(0, 19),
        new Date(new Date().setUTCHours(23, 59, 59)).toISOString().replace('T', ' ').slice(0, 19),
      ],
      listQuery: {
        agencyCode: this.$store.getters.userInfo.agencyCode || '',
        actionType: '',
        userName: '',
        startDate: '',
        endDate: '',
        page: 1,
        count: 20,
      },
      chartQuery: {
        agencyCode: this.$store.getters.userInfo.agencyCode || '',
        actionType: '',
        userName: '',
        type: 1,
      },
      lineChartData: {
        keyData: [],
        valueData: [],
      },
      pickerOptions: {
        disabledDate: time => {
          // 獲取明天的日期
          const tomorrow = new Date()
          tomorrow.setDate(tomorrow.getDate() + 1)
          tomorrow.setHours(0, 0, 0, 0)
          return time.getTime() >= tomorrow.getTime()
        },
      },
    }
  },
  async created() {
    await this.getActionType()
    await this.getList()
    await this.getLogStatistical()
  },
  methods: {
    // 取得行為種類列表 [Get]
    async getActionType() {
      this.listLoading = true
      getActionType()
        .then(resp => {
          this.actionOptions = resp.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 查詢行為紀錄LOG [Post]
    async getList() {
      this.listLoading = true
      if (this.dateFilter && this.dateFilter.length === 2) {
        this.listQuery.startDate = this.dateFilter[0]
        this.listQuery.endDate = this.dateFilter[1]
      }
      getHistoryLogs(this.listQuery)
        .then(resp => {
          this.list = resp.data.data
          this.total = resp.data.total
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
          this.$refs.logTable.bodyWrapper.scrollTop = 0
        })
    },
    async getLogStatistical() {
      this.chartLoading = true
      try {
        let resp = await getLogStatistical(this.chartQuery)
        this.lineChartData.keyData = resp.data.map(item => item.key)
        this.lineChartData.valueData = resp.data.map(item => item.value)
      } catch (error) {
        console.log(error)
      } finally {
        this.chartLoading = false
      }
    },
    async refreshList() {
      ;(this.dateFilter = [
        new Date(
          Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7)
        )
          .toISOString()
          .replace('T', ' ')
          .slice(0, 19),
        new Date(new Date().setUTCHours(23, 59, 59)).toISOString().replace('T', ' ').slice(0, 19),
      ]),
        (this.listQuery = {
          agencyCode: this.$store.getters.userInfo.agencyCode || '',
          actionType: '',
          userName: '',
          startDate: '',
          endDate: '',
          page: 1,
          count: 20,
        })
      await this.getList()
    },
    async refreshChart() {
      this.chartQuery = {
        agencyCode: this.$store.getters.userInfo.agencyCode || '',
        actionType: '',
        userName: '',
        type: 1,
      }
      await this.getLogStatistical()
    },
    //  輸出行為紀錄LOG的EXCEL [Post]
    exportExcel() {
      this.exportExcelLoading = true
      if (this.dateFilter && this.dateFilter.length === 2) {
        this.listQuery.startDate = this.dateFilter[0]
        this.listQuery.endDate = this.dateFilter[1]
      }
      const { page, count, ...rest } = this.listQuery

      let payload = rest
      const url = `/Log/exportHistoryLogsExcel`
      request({
        url: url,
        method: 'post',
        data: payload,
        responseType: 'blob',
      })
        .then(response => {
          let rightNow = new Date()
          let res = rightNow.toISOString().slice(0, 10).replace(/-/g, '')
          const a = document.createElement('a')
          const u = window.URL.createObjectURL(response)
          a.href = u
          a.download = `操作紀錄_${res}.xlsx`
          a.click()
          this.$notify({
            title: '成功',
            message: '操作紀錄Excel處理完成',
            type: 'success',
          })
        })
        .catch(error => {
          console.log('error', error)
          alert(`${error.status}: ${error.statusText || 'error'}`)
        })
        .finally(() => {
          this.exportExcelLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
#log-page {
  .full-height {
    position: relative;
    height: 100%;
  }

  .el-tab-pane {
    min-height: 100%;
  }

  .logTable.el-table {
    width: 100%;
    display: flex;
    flex-direction: column;

    .el-table__body-wrapper {
      max-height: 450px;
      flex: 1;
    }
  }

  /* filter-form 表格篩選列表 */
  .search-form .el-form-item {
    position: relative;
    /* margin-bottom: 0px !important; */
    border: 0.5px solid #ccc;
    border-radius: 3px;
    margin: 3px;
  }

  .search-form .el-form-item:has(button) {
    border-color: transparent;
    margin-top: 8px;
  }

  .search-form .el-form-item__label {
    position: absolute;
    left: 4px;
    z-index: 5;
    top: -9px;
  }

  .search-form .el-form-item__label {
    position: absolute;
    left: 4px;
    z-index: 5;
    top: -9px;
  }

  .search-form .el-input--medium .el-input__inner {
    height: 30px !important;
    margin-top: 12px !important;
    border: none !important;
  }

  .search-form .el-date-editor {
    margin-top: 8px !important;
    height: 37px !important;
    border: none !important;
  }

  @media (min-width: 768px) {
    .search-form {
      .el-select {
        width: 392px;
        max-width: 100%;
      }
    }
  }
}
</style>
